<template>
  <div class="d-flex flex-column flex-root">
    <!--begin::Page-->
    <div class="page d-flex flex-row flex-column-fluid">
      <!--begin::Aside-->
      <!--end::Aside-->
      <!--begin::Wrapper-->
      <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
        <!--begin::Header-->
        <div id="kt_header" class="header">
          <!--begin::Container-->
          <div class="container-fluid d-flex align-items-center flex-wrap justify-content-between"
               id="kt_header_container">
            <!--begin::Page title-->
            <div
                class="page-title d-flex flex-column align-items-start justify-content-center flex-wrap me-2 pb-5 pb-lg-0 pt-7 pt-lg-0"
                data-kt-swapper="true" data-kt-swapper-mode="prepend"
                data-kt-swapper-parent="{default: '#kt_content_container', lg: '#kt_header_container'}">
              <!--begin::Heading-->
              <h1 class="d-flex flex-column text-dark fw-bolder my-0">Danh sách góp ý
                <small class="text-muted fs-6 fw-bold ms-1 pt-1">Số lượng
                  {{ $numberFormat(items.metaData?.total) }}</small></h1>
              <!--end::Heading-->
            </div>
            <!--end::Page title=-->
            <!--begin::Wrapper-->
            <div class="d-flex d-lg-none align-items-center ms-n3 me-2">
              <!--begin::Aside mobile toggle-->
              <div class="btn btn-icon btn-active-icon-primary" id="kt_aside_toggle">
                <!--begin::Svg Icon | path: icons/duotune/abstract/abs015.svg-->
                <span class="svg-icon svg-icon-1 mt-1">
										<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
											<path d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                            fill="black"/>
											<path opacity="0.3"
                            d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                            fill="black"/>
										</svg>
									</span>
                <!--end::Svg Icon-->
              </div>
              <!--end::Aside mobile toggle-->
            </div>
            <!--end::Wrapper-->
          </div>
          <!--end::Container-->
        </div>
        <!--end::Header-->
        <!--begin::Content-->
        <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
          <!--begin::Container-->
          <div class="container-fluid" id="kt_content_container">
            <!--begin::Row-->
            <div class="row g-5 g-lg-10">
              <div class="card card-flush">
                <div class="card-header align-items-center py-5 gap-2 gap-md-5">
                  <!--begin::Card title-->
                  <div class="card-title">
                    <!--begin::Search-->
                    <div class="d-flex align-items-center position-relative my-1">
                      <!--begin::Svg Icon | path: icons/duotune/general/gen021.svg-->
                      <span class="svg-icon svg-icon-1 position-absolute ms-4">
												<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
													<rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                                transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
													<path
                              d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                              fill="black"></path>
												</svg>
											</span>
                      <!--end::Svg Icon-->
                      <input type="text" data-kt-ecommerce-product-filter="search" v-model="filter.walletId"
                             class="form-control form-control-solid w-250px ps-14 me-2" placeholder="Wallet ID">
                      <b-button variant="primary" @click="fetchItems()">Tìm kiếm</b-button>
                    </div>
                    <!--end::Search-->
                  </div>
                  <!--end::Card title-->
                  <!--begin::Card toolbar-->
                  <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
                  </div>
                  <!--end::Card toolbar-->
                </div>
                <!--begin::Card body-->
                <div class="card-body row pt-0 px-0 row mx-0">
                  <!--begin::Table-->
                  <div class="card mb-5 mb-xxl-8 col-md-4 col-12 " v-for="(item, index) in items.data" :key="index">
                    <!--begin::Body-->
                    <div class="card-body pb-0">
                      <!--begin::Header-->
                      <div class="d-flex align-items-center mb-5">
                        <!--begin::User-->
                        <UserCard :user="item.user"/>
                        <!--end::User-->
                        <!--begin::Menu-->
                        <div class="my-0">
                          <button type="button" class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                                  data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end"
                                  @click="showModalReply(item)">
                            <svg style="width: 15px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                              <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                              <path
                                  d="M205 34.8c11.5 5.1 19 16.6 19 29.2l0 64 112 0c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96l-96 0 0 64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"/>
                            </svg>
                          </button>
                        </div>
                        <!--end::Menu-->
                      </div>
                      <!--end::Header-->
                      <!--begin::Post-->
                      <div class="mb-5">
                        <!--begin::Text-->
                        <p class="text-gray-800 fw-normal mb-5">
                          {{ item.content }}
                        </p>
                        <div class="my-1">
                          <b-badge variant="light">{{item.platform}}</b-badge>
                          <b-badge variant="success" v-if="item.status === 'ANSWERED'">Đã trả lời</b-badge>
                          <b-badge variant="warning" v-if="item.status === 'PENDING'">Chưa trả lời</b-badge>
                          <b-badge variant="warning" v-if="item.status === 'WAITING'">Chờ trả lời</b-badge>
                        </div>
                        <!--end::Text-->
                        <!--begin::Toolbar-->
                        <div class="d-flex align-items-center mb-5">
                          <div href="#"
                               class="btn btn-sm btn-light btn-color-muted btn-active-light-success px-4 py-2 me-4">
                            <!--begin::Svg Icon | path: icons/duotune/communication/com012.svg-->
                            <span class="svg-icon svg-icon-3">
														<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                 fill="none">
															<path opacity="0.3"
                                    d="M20 3H4C2.89543 3 2 3.89543 2 5V16C2 17.1046 2.89543 18 4 18H4.5C5.05228 18 5.5 18.4477 5.5 19V21.5052C5.5 22.1441 6.21212 22.5253 6.74376 22.1708L11.4885 19.0077C12.4741 18.3506 13.6321 18 14.8167 18H20C21.1046 18 22 17.1046 22 16V5C22 3.89543 21.1046 3 20 3Z"
                                    fill="black"></path>
															<rect x="6" y="12" width="7" height="2" rx="1" fill="black"></rect>
															<rect x="6" y="7" width="12" height="2" rx="1" fill="black"></rect>
														</svg>
													</span>
                            <!--end::Svg Icon-->{{ item.messages.length }}
                          </div>
                          <div class="text-end text-gray-700">{{ $formatDateTime2(item.createdAt) }}</div>
                        </div>
                        <!--end::Toolbar-->
                      </div>
                      <!--end::Post-->
                      <!--begin::Separator-->
                      <div class="separator mb-4"></div>
                      <!--end::Separator-->
                    </div>
                    <!--end::Body-->
                  </div>
                  <!--end::Table-->
                </div>
                <!--end::Card body-->
              </div>
            </div>
          </div>
          <!--end::Container-->
        </div>
        <!--end::Content-->
      </div>
      <!--end::Wrapper-->
    </div>
    <b-modal v-model="isModalReply" title="Góp ý" size="xs">
      <div v-if="feedbackItem != null">
        <div class="d-flex flex-column align-items-start">
          <!--begin::User-->
          <UserCardSimple :user="feedbackItem.user"/>
          <!--end::User-->
          <!--begin::Text-->
          <div class="p-5 rounded bg-light-info text-gray-900 fw-semibold mw-lg-400px text-start"
               data-kt-element="message-text">
            {{feedbackItem.content}}
            <div class="text-end small">{{$formatDateTime2(feedbackItem.createdAt)}}</div>
          </div>
          <!--end::Text-->
        </div>
        <div class="d-flex flex-column" v-for="(msg, index) in feedbackItem.messages" :class="msg.isAdmin ? 'align-items-end' : 'align-items-start'" :key="index">
          <!--begin::User-->
          <AdminCardSimple :user="feedbackItem.user" :position-left="true" v-if="msg.isAdmin"/>
          <UserCardSimple :user="feedbackItem.user" :position-left="false" v-else/>
          <!--end::User-->

          <!--begin::Text-->
          <div class="p-5 rounded text-gray-900 fw-semibold mw-lg-400px text-end" :class="msg.isAdmin ? 'bg-light-primary text-end' : 'bg-light-info text-start'"
               data-kt-element="message-text">
            {{msg.message}}
            <div class="text-end small">{{$formatDateTime2(msg.createdAt)}}</div>
          </div>
          <!--end::Text-->
        </div>
      </div>
      <template #footer>
        <textarea cols="5" class="form-control" v-model="dataForm.content"></textarea>
        <b-button variant="secondary" @click="isModalReply = false">Đóng</b-button>
        <b-button variant="primary" @click="this.doSubmitMessage">Gửi</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import requestUtil from "@/utils/request-util";
import UserCard from "@/components/commons/UserCard.vue";
import {BModal} from "bootstrap-vue-3";
import UserCardSimple from "@/components/commons/UserCardSimple.vue";
import AdminCardSimple from "@/components/commons/AdminCardSimple.vue";

export default {
  name: "UserFeedback",
  components: {AdminCardSimple, UserCardSimple, BModal, UserCard},
  computed: {},
  data() {
    return {
      isModalReply: false,
      feedbackItem: null,
      filter: {
        walletId: null,
        sort: 'gold,desc'
      },
      items: {
        data: [],
        metaData: {}
      },
      filterLog: {
        walletId: null,
        sort: 'createdAt,desc',
        walletType: 'GOLD'
      },
      itemLogs: {
        data: [],
        metaData: {}
      },
      modalShow: false,
      dataForm: {
        content: null,
        platform: 'WEBSITE',
        id: null
      },
      loading: {
        page: false,
        user: false,
      },
    };
  },
  mounted() {
    this.fetchItems();
  },
  created() {
  },
  methods: {
    showModalReply(item) {
      this.isModalReply = true;
      this.feedbackItem = item;
      this.dataForm.id = item.id;
    },
    async doSubmitMessage() {
      const response = await requestUtil.post('/feedback/message', this.dataForm);
      if (response.status === 200) {
        this.items = response.data
        this.$notify({
          title: 'Thành công',
          type: 'success',
        });
      } else {
        this.$notify({
          title: 'Có lỗi xảy ra',
          type: 'warn',
        });
      }
      await this.fetchItems();
      this.isModalReply = false;
    },
    async fetchItems() {
      const response = await requestUtil.get('/feedback?sort=createdAt,desc', this.filter);
      if (response.status === 200) {
        this.items = response.data
      } else {
        this.$notify({
          title: 'Có lỗi xảy ra',
          type: 'warn',
        });
      }
    },
  },
};

</script>
<style>
</style>